export const contentData = {
  spanish:{
    nodata:'Sin Registro',
    layout:{
      title:'Hospitales',
      navigation:[
        {name:'Catálogos',path:'/catalogs'},
        {name:'Hospitales',path:'/catalogs/hospitals'}
      ],
      menu2:[
        {id:0, label:'Mis datos'},
        {id:1, label:'Horario'},
      ],
      
    },
    filters:[ 
      {id:null, label:'Sin Filtro', url:null},
    ],
    modals:{
      warning_modal:{
        title:'¿Estás seguro?',
        message:'¿Realmente quieres eliminar este registro? Este proceso no puede ser revertido',
        cancelButton:'Cancelar',
        deleteButton:'Eliminar'
      }
    },
    header:['ID','Nombre', 'Nivel','Acreditado', 'CRM ID', 'UCI']
  }
}